import { render, staticRenderFns } from "./AudienceAssociatedCampaigns.vue?vue&type=template&id=9a4f1cc6&"
import script from "./AudienceAssociatedCampaigns.vue?vue&type=script&lang=ts&"
export * from "./AudienceAssociatedCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports